import { render, staticRenderFns } from "./popup-choose-yuan-liao.vue?vue&type=template&id=2fd5dc25&scoped=true"
import script from "./popup-choose-yuan-liao.vue?vue&type=script&lang=js"
export * from "./popup-choose-yuan-liao.vue?vue&type=script&lang=js"
import style0 from "./popup-choose-yuan-liao.vue?vue&type=style&index=0&id=2fd5dc25&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5dc25",
  null
  
)

export default component.exports